<template>
  <v-card :class="[
    'mx-auto price-card d-flex flex-column pa-3 overflow-visible position-relative border-sm',
    isPopular ? 'price-card--popular' : 'price-card--standard'
  ]" min-width="260" rounded="lg">
    <!-- Popular Badge -->
    <div v-if="isPopular" class="d-flex justify-center mt-n6 mb-2">
      <v-chip color="brand-color" density="compact" label rounded="lg" variant="flat"
        class="text-white text-caption font-weight-medium price-card__badge">
        🔥 Most Popular
      </v-chip>
    </div>
    <!-- Card Header | Title & Price & Current Chip-->
    <v-card-title :class="[
      'd-flex flex-column align-start justify-center flex-shrink-0 px-4 py-1 text-left w-100',
      isPopular ? '' : 'mt-1'
    ]">
      <div class="d-flex align-center justify-space-between w-100">
        <span class="font-weight-bold text-uppercase text-left plan-name text-grey-darken-1">
          {{ plan.name }}
        </span>
        <v-chip v-if="isCurrent && subscriptionStatus !== SUBSCRIPTION_STATUS.DELETED"
          color="info" density="compact" rounded="pill"
          variant="flat" class="text-white text-caption font-weight-bold flex-shrink-0 py-2 current-plan-chip">
          Current Plan
        </v-chip>
      </div>
      <div class="d-flex align-baseline w-100 price-card__pricing">
        <span class="font-weight-bold text-grey-darken-4 plan-price text-left mr-2">
          ${{ plan.price }}
        </span>
        <span class="text-grey-darken-3 ma-0 plan-price-interval text-left">
          / month
        </span>
      </div>
      <p class="text-grey-darken-1 ma-0 mt-n2 plan-billed text-left">
        Billed {{ interval === 'month' ? 'monthly' : 'yearly' }}
      </p>
    </v-card-title>

    <!-- Header Divider -->
    <v-divider class="mb-4" color="blue-grey-lighten-1"></v-divider>

    <!-- Features Section -->
    <v-card-text class="px-4 py-0 flex-shrink-0">
      <v-list class="pa-0 bg-transparent plan-features">
        <v-list-item v-for="(feature, index) in plan.cardText" :key="index" :class="['pa-0 mb-2']" min-height="auto">
          <template v-slot:prepend>
            <span class="mx-2" :class="getFeatureIncluded(feature) ? 'text-success' : 'text-error'">
              {{ getFeatureIncluded(feature) ? '✔' : '✘' }}
            </span>
          </template>
          <v-list-item-title class="text-grey-darken-2 font-weight-regular plan-features-item">
            {{ getFeatureLabel(feature) }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-card-text>

    <!-- Spacer to push button to bottom -->
    <div class="flex-grow-1"></div>

    <!-- Action Button -->
    <v-card-actions v-if="!shouldHideButton" class="pa-4 py-0 flex-shrink-0">
      <v-btn :color="plan.color" variant="flat" block class="text-none text-white font-weight-bold" elevation="0" @click="$emit('select-plan', plan)">
        {{ buttonText }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { SUBSCRIPTION_STATUS } from '@/shared/constants/pricing/data'

export default {
  name: 'PCard',
  data() {
    return {
      SUBSCRIPTION_STATUS
    }
  },
  props: {
    plan: { type: Object, required: true },
    interval: { type: String, default: 'month' },
    isCurrent: { type: Boolean, default: false },
    isPopular: { type: Boolean, default: false },
    subscriptionStatus: { type: String, default: SUBSCRIPTION_STATUS.NONE },
    currentSubscriptionStatus: { type: String, default: SUBSCRIPTION_STATUS.NONE },
    isPastDue: { type: Boolean, default: false }
  },
  computed: {
    // Check if button should be hidden (paused/cancelled/past due and not current)
    shouldHideButton() {
      const blockedStatuses = [SUBSCRIPTION_STATUS.PAUSED, SUBSCRIPTION_STATUS.DELETED, SUBSCRIPTION_STATUS.PAST_DUE]
      // Hide button if status is blocked (or user is past due) and not current plan
      return (blockedStatuses.includes(this.subscriptionStatus) || this.isPastDue) && !this.isCurrent
    },
    // Get button text
    buttonText() {
      return this.isCurrent && this.subscriptionStatus !== SUBSCRIPTION_STATUS.NONE
        ? 'Manage Plan'
        : 'Choose Plan'
    }
  },
  methods: {
    getFeatureIncluded(feature) {
      if (feature && typeof feature === 'object') {
        return feature.included !== false
      }
      return true
    },
    getFeatureLabel(feature) {
      return typeof feature === 'string' ? feature : feature?.label || ''
    }
  }
}
</script>
